import { makeStyles, tokens } from '@fluentui/react-components';
import { NavDrawer, NavDrawerBody, NavItem, type NavItemProps } from '@fluentui/react-nav';
import {
    createFileRoute,
    createLink,
    Outlet,
    redirect,
    useChildMatches,
} from '@tanstack/react-router';
import { forwardRef, memo, useState } from 'react';
import { useMediaQuery } from 'usehooks-ts';

const useStyles = makeStyles({
    main: {
        display: 'grid',
        gap: '1em',
        paddingLeft: '10px',
        gridTemplateRows: 'auto minmax(0, 1fr)',
        minWidth: 0,
        minHeight: 0, // 🔥 extrem wichtig
        //overflow: 'auto',
    },
    mainWithBorder: {
        borderLeft: `1px solid ${tokens.colorNeutralStroke1}`,
        boxShadow: `-4px 0 4px -4px rgba(0,0,0,0.15)`,
    },
    navBody: {
        paddingBottom: tokens.spacingHorizontalXS,
        paddingTop: tokens.spacingHorizontalSNudge,
    },
    navDrawer: {
        maxHeight: 'unset',
    },
    root: {
        display: 'grid',
        gridTemplateColumns: 'auto minmax(0, 1fr)',
        minWidth: 0,
        overflow: 'hidden',
    },
});

const IndexLayout = () => {
    const styles = useStyles();
    const isSmall = useMediaQuery('(max-width: 900px)');

    return (
        <div className={styles.root}>
            <Nav />
            <main className={`${styles.main} ${!isSmall ? styles.mainWithBorder : ''}`}>
                <Outlet />
            </main>
        </div>
    );
};

export const Route = createFileRoute('/_index')({
    beforeLoad: (ctx) => {
        if (ctx.location.pathname === '/') {
            throw redirect({ to: '/process-definitions', replace: true });
        }
    },
    component: IndexLayout,
});

const Nav = () => (
    <NavDrawerMemo
        path={useChildMatches({
            select: (matches) => matches[0].pathname ?? '',
        })}
    />
);

const NavDrawerMemo = memo<{ path: string }>((props) => {
    const [open, setOpen] = useState(false);
    const isSmall = useMediaQuery('(max-width: 900px)');
    const styles = useStyles();

    return (
        <>
            {isSmall && (
                <button onClick={() => setOpen(true)} style={{ margin: '8px' }}>
                    ☰
                </button>
            )}

            <NavDrawer
                className={styles.navDrawer}
                type={isSmall ? 'overlay' : 'inline'}
                open={isSmall ? open : true}
                onOpenChange={(_, data) => setOpen(data.open)}
                selectedValue={props.path}
            >
                <NavDrawerBodyMemo />
            </NavDrawer>
        </>
    );
});
NavDrawerMemo.displayName = 'NavDrawerMemo';

const NavDrawerBodyMemo = memo(() => {
    const styles = useStyles();
    return (
        <NavDrawerBody className={styles.navBody}>
            <NavLink to="/process-definitions" value="/process-definitions">
                Prozessdefinitionen
            </NavLink>
            <NavLink to="/process-definitions-archived" value="/process-definitions-archived">
                Archiv
            </NavLink>
            <NavLink to="/process-definitions-template" value="/process-definitions-template">
                Vorlagen
            </NavLink>
            {/*<NavLink to="/jobs" value="/jobs">
                Jobs
            </NavLink>*/}
        </NavDrawerBody>
    );
});
NavDrawerBodyMemo.displayName = 'NavDrawerBodyMemo';

const NavLink = createLink(
    forwardRef<HTMLAnchorElement, NavItemProps>((props, ref) => <NavItem {...props} ref={ref} />)
);
